export enum TariffTypes {
    Pass = 'pass',
    Ticket = 'ticket',
    Domain = 'domain',
    Caps = 'caps',
}

export enum TariffTypesForPriceType {
    Pass = 1,
    Ticket = 2,
}
